// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__39goI","itemTitle":"ClientEmergencyInfo_itemTitle__2Ymh9","itemText":"ClientEmergencyInfo_itemText__2iQoh"};